import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the polygon range array
 * @param {string[]} polygonRanges - Array with polygon range values
 */
export const setPolygonRanges = (polygonRanges) => {
  searchPageStore.setState({ polygonRanges })
}

/**
 * Adds a polygon range to the array
 * @param {string} polygonRange - Polygon range to add
 */
export const addPolygonRange = (polygonRange) => {
  const state = searchPageStore.getState()
  const currentPolygonRanges = state.polygonRanges || []

  if (!currentPolygonRanges.includes(polygonRange)) {
    searchPageStore.setState({ polygonRanges: [...currentPolygonRanges, polygonRange] })
  }
}

/**
 * Removes a polygon range from the array
 * @param {string} polygonRange - Polygon range to remove
 */
export const removePolygonRange = (polygonRange) => {
  const state = searchPageStore.getState()
  const currentPolygonRanges = state.polygonRanges || []

  searchPageStore.setState({
    polygonRanges: currentPolygonRanges.filter((p) => p !== polygonRange),
  })
}

/**
 * Sets the minimum polygon filter
 * @param {number|undefined} minPolygon - Minimum polygon value or undefined
 */
export const setMinPolygon = (minPolygon) => {
  searchPageStore.setState({ minPolygon })
}

/**
 * Sets the maximum polygon filter
 * @param {number|undefined} maxPolygon - Maximum polygon value or undefined
 */
export const setMaxPolygon = (maxPolygon) => {
  searchPageStore.setState({ maxPolygon })
}

/**
 * Clears all polygon filters
 */
export const clearPolygon = () => {
  searchPageStore.setState({
    polygonRanges: DEFAULT_STATE.polygonRanges,
    minPolygon: DEFAULT_STATE.minPolygon,
    maxPolygon: DEFAULT_STATE.maxPolygon,
  })
}
